<div class="chartContainer" [style.width]="width" [style.height]="height">
  <canvas (click)="chartClicked($event)" [attr.id]="myId">
    <p>This is a chart. If you can see this, your browser doesn't support the Canvas tag.</p>
  </canvas>
</div>
